// extracted by mini-css-extract-plugin
module.exports = {"info-layout":"_13dSA","infoLayout":"_13dSA","icon-avatar":"_2eT0N","iconAvatar":"_2eT0N","pricing-cta":"_2gxlY","pricingCta":"_2gxlY"};